<div id="file-selection">
  <input type="file" style="display: none" #fileInput accept="image/*"
    (change)="onChangeFileInput()">
  <button mat-raised-button [color]=color (click)="onClickFileInputButton()">
    <mat-icon>attach_file</mat-icon>
    <ng-content></ng-content>
  </button>
  {{value?.name}}
</div>
